<template>
  <div class="dcContainer">

    <div class="dcInner">
      <div class="d-flex">
        <v-icon @click.native.passive="update">mdi-refresh</v-icon>
        <v-text-field outlined dense
                      hide-details
                      :value="search" @input="updateSearch"
                      clearable
                      label="Search"
        ></v-text-field>
        <v-icon @click.native.passive="copy" class="ml-4 mr-4">mdi-content-copy</v-icon>
        <v-icon @click.native.passive="clear">mdi-delete-forever</v-icon>
      </div>

      <div class="dcOutput">
        <div v-for="line of outputLines" class="dcLine">{{ line }}</div>
      </div>
    </div>

  </div>
</template>

<script>
import {copyToClipboard} from "@/util/clipboard";

let lines = [];
export default {
  name: "DebuggingConsole",
  data: () => ({
    search: '',
    outputLines: [],
  }),
  computed: {
    // filteredLines() {
    //   this.lines.filter(l => !this.search || l.indexOf(this.search) !== -1);
    // }
  },
  mounted() {
    let self = this;
    try {
      let origConsole = console.log;
      console.log = function log() {
        self.outputConsole('' + arguments[0]);
        origConsole.apply(console, arguments);
      };
    } catch (e) {
      alert('Error extending console: ' + e.message);
    }
  },
  methods: {
    copy() {
      let c = lines.join('<br>\n');
      copyToClipboard(c, this);
    },
    clear() {
      lines = [];
      this.outputLines = [];
    },
    update() {
      let term = this.search.toLowerCase();
      this.outputLines = lines.filter(l => !this.search || l.toLowerCase().indexOf(term) !== -1);
    },
    outputConsole(text) {
      lines.push(text);
      // let dcOutput = window.document.getElementById('dcOutput');
      // dcOutput.value = dcOutput.value + text + '\n';
      // dcOutput.scrollTop = dcOutput.scrollHeight;
    },
    updateSearch(v) {
      this.$nextTick(() => {
        this.search = v;
      });
    },
  }
}
</script>

<style scoped lang="scss">
.dcContainer {
  position: fixed;
  bottom: 40px;
  left: 0;
  height: 60vh;
  width: 100vw;
  pointer-events: none;
  padding: 20px;
  z-index: 888;
}

.dcInner {
  pointer-events: all;
  background-color: rgba(white, 0.8);
  color: black;
  border: 1px solid #333;
  width: 100%;
}

.dcOutput {
  font-size: 0.7em;
  overflow-y: scroll;
  max-height: calc(60vh - 120px);
}

.dcLine {
  border-bottom: 1px solid #bbb;
}

</style>
